import { isBRServer } from '@/utils/Validators/validation';

const FAST_CHECKOUT_PRODUCTS_BR = {
  STUDIO_PRO: '485',
  STUDIO_PRO_TRIAL: '482',
  GATOR_BACKUP_CORE: '569',
  GATOR_BACKUP_PLUS: '572',
  GATOR_BACKUP_ADVANCED: '575',
  GATOR_BACKUP_MAX: '578',
};

const FAST_CHECKOUT_PRODUCTS_ES = {
  STUDIO_PRO: '290',
  STUDIO_PRO_TRIAL: '287',
  GATOR_BACKUP_CORE: '344',
  GATOR_BACKUP_PLUS: '347',
  GATOR_BACKUP_ADVANCED: '350',
  GATOR_BACKUP_MAX: '353',
};

const FAST_CHECKOUT_CYCLES = {
  ANNUALLY: 'annually',
  SEMIANNUALLY: 'semiannually',
  QUARTERLY: 'quarterly',
  MONTHLY: 'monthly',
};

const FAST_CHECKOUT_PAYMENT_METHODS = {
  CREDIT_CARD: isBRServer ? 'braspag_credit' : 'dlocal',
  PIX: 'gp_pix',
  PIX_REC: 'gp_rec_pix',
  GP_BOLETO: 'gp_boleto',
  GP_PAYPAL: 'gp_paypal',
  CUPON_DE_PAGO: 'dlocalcash', // Other brands
  CUPON_DE_PAGO_MX: 'payu_boleto', // MX
};

const FAST_CHECKOUT_CREDIT_CARD_METHODS = {
  NEW: 'new',
  ALREADY_REGISTERED: 'alreadyRegistered',
};

const CC_FLAGS = {
  VISA: 'visa',
  MASTERCARD: 'mastercard',
};

const DISCOUNT_TYPES = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed',
};

const FAST_CHECKOUT_INSTALLMENTS = {
  BRASPAG_CREDIT_1X: 'braspag_credit_1x',
  BRASPAG_CREDIT_2X: 'braspag_credit_2x',
  BRASPAG_CREDIT_3X: 'braspag_credit_3x',
  BRASPAG_CREDIT_4X: 'braspag_credit_4x',
  BRASPAG_CREDIT_5X: 'braspag_credit_5x',
  BRASPAG_CREDIT_6X: 'braspag_credit_6x',
  BRASPAG_CREDIT_7X: 'braspag_credit_7x',
  BRASPAG_CREDIT_8X: 'braspag_credit_8x',
  BRASPAG_CREDIT_9X: 'braspag_credit_9x',
  BRASPAG_CREDIT_10X: 'braspag_credit_10x',
  BRASPAG_CREDIT_11X: 'braspag_credit_11x',
  BRASPAG_CREDIT_12X: 'braspag_credit_12x',
};

const COUNTRY_DOCUMENT_RULES = {
  ar: { min: 7, max: 11 },
  bo: { min: 5, max: 20 },
  do: { min: 7, max: 11 },
  ec: { min: 5, max: 20 },
  pe: { min: 8, max: 11 },
  uy: { min: 6, max: 12 },
  mx: { min: 5, max: 18 },
  cl: { min: 5, max: 10 },
  co: { min: 5, max: 10 },
};

const POSTAL_CODE_LENGTH = {
  BR: 9,
  MX: 5,
  CL: 7,
  CO: 6,
  other: 30,
};

const DDIS_BY_COUNTRY = {
  co: '+57',
  mx: '+52',
  cl: '+56',
  br: '+55',
  default: '+55',
};

export {
  FAST_CHECKOUT_PRODUCTS_BR,
  FAST_CHECKOUT_PRODUCTS_ES,
  FAST_CHECKOUT_PAYMENT_METHODS,
  FAST_CHECKOUT_CYCLES,
  FAST_CHECKOUT_CREDIT_CARD_METHODS,
  CC_FLAGS,
  DISCOUNT_TYPES,
  FAST_CHECKOUT_INSTALLMENTS,
  COUNTRY_DOCUMENT_RULES,
  POSTAL_CODE_LENGTH,
  DDIS_BY_COUNTRY,
};
